@if (showForm$ | async) {
  <div class="user-info-container">
    <form class="user-info-form" [formGroup]="userInfoForm" (ngSubmit)="onSubmit()">
      <div class="user-info-title" [innerHTML]="component.primary.title_and_text[0].text | safeHtml"></div>
      <div class="user-info-row">
        <div class="user-info-field">
          <label for="firstName">{{ 'CART_CHECKOUT.FIRST_NAME' | translate }}</label>
          <input id="firstName" name="firstName" type="text" formControlName="firstName" />
          @if (userInfoForm.get('firstName').touched && userInfoForm.get('firstName').invalid) {
            <div class="user-info-error">
              {{ 'CART_CHECKOUT.FIRST_NAME_REQ' | translate }}
            </div>
          }
        </div>
        <div class="user-info-field">
          <label for="lastName">{{ 'CART_CHECKOUT.LAST_NAME' | translate}}</label>
          <input id="lastName" name="lastName" type="text" formControlName="lastName" />
          @if (userInfoForm.get('lastName').touched && userInfoForm.get('lastName').invalid) {
            <div class="user-info-error">
              {{ 'CART_CHECKOUT.LAST_NAME_REQ' | translate }}
            </div>
          }
        </div>
      </div>
      <div class="user-info-row">
        <div class="user-info-field full-width">
          <label for="email">{{ 'CART_CHECKOUT.EMAIL_ADDRESS' | translate }}</label>
          <input id="email" name="email" type="email" formControlName="email" />
          @if (userInfoForm.get('email').touched && userInfoForm.get('email').invalid) {
            <div class="user-info-error">
              @if (userInfoForm.get('email').errors?.['required']) {
                <span>{{ 'CART_CHECKOUT.ERROR_EMAIL_REQ' | translate }}</span>
              }
              @if (userInfoForm.get('email').errors?.['email']) {
                <span>{{ 'CART_CHECKOUT.ERROR_EMAIL_INVAILD' | translate }}</span>
              }
            </div>
          }
        </div>
      </div>
      <p class="user-info-disclaimer" [innerHTML]="component.primary.disclaimer[0].text | safeHtml"></p>
      <button type="submit" id="submitUserInfoButton" class="user-info-submit" [disabled]="isLoading">
        @if (!isLoading) {
          <span [innerHTML]="component.primary.submit_button | safeHtml"></span>
        }
        @if (isLoading) {
          <div class="spinner"></div>
        }
      </button>
      <!-- Error message -->
      @if (error$ | async; as error) {
        <div class="user-info-error mt-2">
          {{ 'CART_CHECKOUT.EMAIL_ALREADY_REGISTERED' | translate }}
        </div>
      }
    </form>
  </div>
}

@if (!(showForm$ | async)) {
  <div class="user-info-container user-info-thankyou">
    <div class="user-info-thankyou-content">
      <div [innerHTML]="component.primary.reply_message[0].text | safeHtml"></div>
    </div>
  </div>
}